export default __webpack_public_path__ + "static/media/acceX.793a7487.svg";